import BaseModel from "../core/BaseModel";
export default class UserWarningModel extends BaseModel {
  constructor() {
    super(
      {
        name: "user_warning",
        tableName: "user_warning",
        label: "Danh Sách Nhân viên sắp hết hạn",
        display_key: 'fullname',
      },
      {
        stt: {
          name: "stt",
          label: "STT",
          type: "Computed",
          class: "xs-col",
          computed: (data, index) => {
            data.stt = index + 1;
          },
        },
        id: {
          name: "id",
          type: "Uuid",
          label: "ID",
          primaryKey: true,
          display: false,
        },
        avatar : {
          name: 'avatar', 
          type: "Image", 
          label: 'Hình đại diện',
        },
        fullname: {
          name: "fullname",
          type: "String",
          label: "Tên hiển thị",
          // class: "large-col",
          filter: { type: "input", match: "contains" },
        },
        contractor_filter: {
          name: "contractor_filter",
          type: "String",
          label: "Tên nhà thầu",
          // class: "large-col",
          filter: { type: "input", match: "contains" },
        },
        text_warning: {
          name: "text_warning",
          type: "CustomUrl",
          label: "Nội dung cảnh báo",
          computed: (data) => {
            data.text_warning = '';
          },
        },
      }
    );
  }
}
